import { useStore, useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { roleModel } from '~/entities/Role'
import { EditRole, roleEmployeeModal } from '~/features/Roles/EditRole'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'
import { NotFound } from '~/shared/ui/NotFound'

export const EditRolePage = () => {
  const { t } = useTranslation()
  const { roleId } = useParams<{ roleId: string }>()

  const isLoading = useStore(roleModel.requestFx.pending)
  const roleName = useStoreMap(roleEmployeeModal.$role, (employee) =>
    employee?.getName(),
  )

  const breadcrumbs: BreadcrumbsList = useMemo(
    () => [
      { titleI18n: 'roles', link: '/settings/roles' },
      { title: roleName as string },
    ],
    [roleName],
  )

  const error = roleModel.useRoleError(roleId as string)

  if (!roleId || error) {
    return <NotFound message={t('alert.role load error')} />
  }

  return (
    <PageContainer title={t('role card')}>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} lastLoading={isLoading} />
        <PageTitle loading={isLoading}>{roleName}</PageTitle>
      </Container>
      <EditRole roleId={roleId} />
    </PageContainer>
  )
}
